import { lazy, FC } from 'react';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';
import { useFragment, graphql } from 'react-relay';

import { PdpSharedUrgencyLazy_item$key } from './__generated__/PdpSharedUrgencyLazy_item.graphql';

const PspSharedUrgency = lazy(
    () => import(/* webpackChunkName: "PdpSharedUrgency" */ './PdpSharedUrgency')
);

type Props = {
    item: PdpSharedUrgencyLazy_item$key;
};

const itemFragment = graphql`
    fragment PdpSharedUrgencyLazy_item on Item {
        ...PdpSharedUrgency_item
    }
`;

export const PdpSharedUrgencyLazy: FC<Props> = ({ item: itemRef }) => {
    const item = useFragment(itemFragment, itemRef);

    return (
        <ClientSuspense fallback={null}>
            <PspSharedUrgency item={item} />
        </ClientSuspense>
    );
};
